import { FormerMemberPortal } from '../../former-member/components/FormerMemberPortal';

export default function FormerMemberPage() {
    return <FormerMemberPortal />;
}
